import moment from 'moment'

export function formatDate(val){
	return moment(val).format("DD MMM YYYY")
}

//this is specific to Xero date formatting
export function formatXeroDate(val){
	//extract UTC time from default Xero format
	const time =  val.split('(').pop().split('+')[0]
	return moment(parseInt(time)).format("DD MMM YYYY")
}